import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navigationbar from '../components/Navigationbar';
import Footer from '../components/Footer';
import Apiservice from '../services/Apiservice';
import CommonFunctions from '../components/CommonFunctions';
import { RenderNavigation, RenderFooter, RenderLeftAside, RenderRightAside } from '../components/ReusableFragments';

const TeamInfos = () => {
  const [teams, setTeams] = useState([]);
  const [pointsTable, setPointsTable] = useState([]);
  const [fixturesResults, setFixturesResults] = useState([]);
  const [tournamentDetails, setTournamentDetails] = useState([]);
  const [tournamentId, setTournamentId] = useState('3');
  const [todaySfs, setTodaySfs] = useState([]);
  const [posts, setPosts] = useState([]);
  const [birthdays, setBirthdays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Apiservice.getwplteaminfo(tournamentId);
        setTeams(response.data.teams);
        setPointsTable(response.data.points_table);
        setFixturesResults(response.data.fixtures);
        setTournamentDetails(response.data.tournament);
        setTodaySfs(response.data.total_sfs[0]);
        setPosts(response.data.posts || []);
        setBirthdays(response.data.bdays || []);
      } catch (err) {
        setError('Failed to fetch data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [tournamentId]);

  if(loading) {
    return <div className="progress" style={{height: "4px"}}>
    <div 
      className="progress-bar progress-bar-animated" 
      role="progressbar" 
      style={{ width: '100%' }} 
      aria-valuenow={100} 
      aria-valuemin={0} 
      aria-valuemax={100}>
    </div>
  </div>;
  }

  if(error) {
    return <div>{error}</div>;
  }

  return (
    <React.Fragment>
      <div className="bg-fluid"></div>
      <RenderNavigation />
      <div className='container-fluid'>
        <nav aria-label="breadcrumb" className=''>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/" className="text-muted text-decoration-none">Home</Link></li>
            <li className="breadcrumb-item text-white active" aria-current="page">WPL Teams</li>
          </ol>
        </nav>

        <div className='row'>
          <div className='col-md-9'>
            <h1 className='fs-4 text-white'>Women's Premier League Teams</h1>
            <img src="images/banner/wpl_team_captains_wpl_cricinfo.webp" alt="WPL Team Captains" className='img-fluid rounded shadow mb-4' />
            <div className='row'>
              {teams.map((items, index) => (
                <div className='col-md-6' key={index}>
                  <div className={`card mb-3 shadow team-${items.team_shortcode.toLowerCase()} text-white`}>
                    <div className="row g-0">
                      <div className="col-md-2 text-center">
                        <img src={`images/logos/${items.team_shortcode.toLowerCase()}-lg-wplcricinfo.webp`} className="img-fluid rounded-start" alt={`${items.team_shortcode} logo`} />
                      </div>
                      <div className="col-md-10">
                        <div className="card-body py-1">
                          <span className="float-shortcode">{items.team_shortcode}</span>
                          <h2 className="card-title mb-0 fs-5">{items.team_name}</h2>
                          <p className="card-text small mb-0">Captain: <strong>{items.captain_fullname}</strong> {items.team_shortcode !== 'RCB-W' && items.team_shortcode !== 'MI-W' ? <i className="bi bi-airplane icon-rotate"></i> : ''}</p>
                          <p className="card-text small mb-0">Coach: <strong>{items.coach}</strong></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className='col-md-12'>
              <hr />
              <h2 className='fs-5'>News &amp; Updates</h2>
              <div className='row'>
                {posts && posts.map((item, index) => (
                  <div className='col-md-3 mb-4' key={index}>
                    <div className="card shadow h-100">
                      <img src={`http://wplcricinfo.com/wpl/admin/${item.imgUrl}`} className="card-img-top" alt={item.title} />
                      <div className="card-body p-2 h-100">
                        <h3 className="card-title fs-6"><Link className="text-decoration-none" to={`/post/${item.id}/${CommonFunctions.formatPostTitleForLink(item.title)}`}>{item.title}</Link></h3>
                        <p className="card-text"><small className="text-body-secondary">Posted on: {CommonFunctions.getPostDateFormat(item.created_at)}</small></p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <RenderRightAside todaySfs={todaySfs} pointsTable={pointsTable} playerBdays={birthdays}  />
          </div>
        </div>
      </div>
      <RenderFooter />
    </React.Fragment>
  );
};

export default TeamInfos;